/* eslint-disable react-refresh/only-export-components */
import { SheetContent } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/sheetContent';
import { createContext, useContext, useState } from 'react';

export const SheetContext = createContext<{
  open: boolean;
  setOpen: (open: boolean) => void;
  content: SheetContent | null;
  setContent: (content: SheetContent | null) => void;
}>({
  open: false,
  setOpen: () => {},
  content: null,
  setContent: () => {},
});

export function SheetContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState<SheetContent | null>(null);

  return (
    <SheetContext.Provider value={{ open, setOpen, content, setContent }}>
      {children}
    </SheetContext.Provider>
  );
}

export function useSheetContext() {
  const context = useContext(SheetContext);

  return {
    ctx: context,
  };
}
